import { IForm } from '@/components/types'
import { useSearchDays, useSearchDuration } from '@/hooks/useSearch'
const durationOptions = useSearchDuration()
const daysOptions = useSearchDays()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'channelId',
      type: 'select',
      label: '直播间',
      placeholder: '请选择直播间',
      clearable: true
    },
    {
      field: 'consumerNickName',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'consumerWxUnionId',
      type: 'input',
      label: '客户unionId',
      placeholder: '请输入客户unionId'
    },
    {
      field: 'duration',
      type: 'select',
      label: '访问时长',
      placeholder: '请选择访问时长',
      options: durationOptions,
      clearable: true
    },
    {
      field: 'accessTime',
      type: 'dateTimePicker',
      label: '访问时间',
      // rules: [
      //   {
      //     required: true,
      //     message: '请选择访问时间',
      //     trigger: 'blur'
      //   }
      // ],
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      field: 'deptId',
      type: 'select',
      label: '部门',
      placeholder: '请选择部门',
      clearable: true
    },
    {
      field: 'empIds',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    }
  ]
}
